import PlatformActions from './PlatformActions'

export default class HABANEROEGAMEActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'HABANERO',
      gameType: 'EGAME',
      gameCode: 'HABANERO-EGAME-001',
    }

    this.gameName = 'Aces & Eights 1 Hand'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      roundId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: roundId.replaceAll('-', ''), // 608e2a47d26ef1119240020001000beb
      roundId, // 608e2a47-d26e-f111-9240-020001000beb
      betType: null,
      currency,
      betTime, // 2026-06-23T15:08:04.136+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {},
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      settleTxnId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: settleTxnId, // dd34ee4bd26ef11190ec020002002a25
      refPlatformTxId: roundId.replaceAll('-', ''), // 608e2a47d26ef1119240020001000beb
      settleType: 'refPlatformTxId',
      updateTime, // 2026-06-23T15:08:12.243+08:00
      roundId, // 608e2a47-d26e-f111-9240-020001000beb
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        isEndRound: 'true',
      },

    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: roundId.replaceAll('-', ''), // 608e2a47d26ef1119240020001000beb
      roundId, // 608e2a47-d26e-f111-9240-020001000beb
      gameInfo: {},
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
